import React from 'react';

const RelationshipFilter = ({ selectedRelationship, onRelationshipChange }) => {
  // Using the actual relationship constants from backend with emojis
  const relationships = [
    // Romantic
    { id: 'SPOUSE_PARTNER', emoji: '💑', label: 'Spouse/Partner' },
    { id: 'GIRLFRIEND_BOYFRIEND', emoji: '💕', label: 'Partner' },

    // Close Family  
    { id: 'PARENT', emoji: '👨‍👩‍👧‍👦', label: 'Parent' },
    { id: 'CHILD', emoji: '👶', label: 'Child' },
    { id: 'SIBLING', emoji: '👫', label: 'Sibling' },
    { id: 'GRANDPARENT', emoji: '👵', label: 'Grandparent' },

    // Extended Family
    { id: 'AUNT_UNCLE', emoji: '👨‍👩‍👧', label: 'Aunt/Uncle' },
    { id: 'COUSIN', emoji: '👪', label: 'Cousin' },
    { id: 'NIECE_NEPHEW', emoji: '👧👦', label: 'Niece/Nephew' },

    // Friends
    { id: 'FRIEND', emoji: '👫', label: 'Friend' },
    { id: 'BEST_FRIEND', emoji: '👯', label: 'Best Friend' },

    // Professional
    { id: 'COWORKER', emoji: '👔', label: 'Coworker' },
    { id: 'BOSS', emoji: '👨‍💼', label: 'Boss' },
    { id: 'TEACHER', emoji: '👩‍🏫', label: 'Teacher' },
    { id: 'CLIENT', emoji: '🤝', label: 'Client' }
  ];

  return (
    <div>
      <h3 className="font-medium text-accent-800 mb-3 flex items-center">
        👥 Who are you shopping for?
      </h3>

      <div className="grid grid-cols-3 gap-2">
        {relationships.map((relationship) => (
          <button
            key={relationship.id}
            onClick={() => onRelationshipChange(relationship.id)}
            className={`p-2 rounded-lg text-center transition-all duration-200 ${selectedRelationship === relationship.id
              ? 'border-2 border-primary-600 bg-primary-200 shadow-inner transform scale-95'
              : 'border-2 border-accent-200 hover:border-accent-300 bg-white hover:bg-accent-50 shadow-sm'
              }`}
          >
            <div className="text-lg mb-1">{relationship.emoji}</div>
            <div className={`text-xs ${selectedRelationship === relationship.id
              ? 'font-bold text-primary-800'
              : 'font-medium text-accent-600'
              }`}>
              {relationship.label}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RelationshipFilter;